import { Faq } from '@repo/ui'

export default function FaqPage() {
  return <Faq faqLength={13} faqSourceLocale={'common'} data-testid={'faq'} />
}
